import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Executes the duplicate search by relaying to the collection's list action
 * with the name and jobTitleId as additional filters. Uses 'switch' strategy to
 * cancel in-flight requests when new ones arrive.
 */
export const executeLoad = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.loadDuplicates.relay(
      (forwardTo, additionalFilters) =>
        rxjs.of(
          forwardTo(
            plugin.collection.plugins.dataOperationPlugin.feature.actions.list,
            {
              input: {
                filter: {
                  additionalFilters,
                },
              },
              output: ({ response }) => response.entities,
            },
          ),
        ),
      { strategy: 'switch' },
    ).asObservable,
)
